export const INTEGRATION_SENDER_KIND = "integration" as const;

export interface IntegrationSender {
  kind: typeof INTEGRATION_SENDER_KIND;
  webhook_id: string;
  display_name: string;
}

export function parseIntegrationSender(raw: unknown): IntegrationSender | undefined {
  if (!raw || typeof raw !== "object") return undefined;
  const value = raw as Record<string, unknown>;
  if (value.kind !== INTEGRATION_SENDER_KIND) return undefined;
  if (typeof value.webhook_id !== "string" || !value.webhook_id) return undefined;
  if (typeof value.display_name !== "string" || !value.display_name) return undefined;
  return {
    kind: INTEGRATION_SENDER_KIND,
    webhook_id: value.webhook_id,
    display_name: value.display_name,
  };
}

export function integrationAuthorId(webhookId: string): string {
  return `integration:${webhookId}`;
}

export function isIntegrationMessage(message: { sender?: { kind?: string } | null }): boolean {
  return message.sender?.kind === INTEGRATION_SENDER_KIND;
}
